import { useState } from "react";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import Button from "../Reusable/Button";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { usePDFPrintHook, useDownload } from "@careinfo/layout";
import moment from "moment";
import Modal from "../Reusable/Modal";
import MakePayment from "./MakePayment";
const InvoicePreview = (props: any) => {
  const { order, id } = props;
  const [makePayment, setMakePayment] = useState(false);

  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });
  const { download } = useDownload();
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handleDownloadExcel = async () => {
    try {
      await download(
        `${APIS.RIDER_INVOICE}${id}/download-order/`,
        `${order?.user?.full_name}-invoice-${moment().format(
          "MMMM-Do-YYYY-h-mm-ss"
        )}.xlsx`
      );
    } catch (err) {
      console.log(err);
    }
  };

  const { data: clientData } = useGetHook({
    queryKey: [`client-setting`],
    url: `${APIS.CLIENT_SETTING}`,
    params: {},
  });
  const handlePrint = async () => {
    const url = `${APIS.RIDER_INVOICE}${id}/print-pdf-invoice/`;
    let formData = {};
    try {
      const res = await downloadPrint(url);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div className={tw`w-full px-4 sm:px-6 `}>
        <div className={tw`mb-6 flex justify-end gap-x-3 `}>
          <div className={tw`w-96 flex gap-x-8`}>
            <Button
              label="Print"
              type="button"
              isLoading={isPrintLoading}
              onClick={handlePrint}
            />
            <Button
              label="Download"
              type="button"
              onClick={handleDownloadExcel}
            />
            {userProfileType?.is_merchant ? (
              ""
            ) : (
              <AccessControl
                children={
                  <Button
                    label={order?.status === "paid" ? "PAID" : "Make Payment"}
                    type="button"
                    disabled={order?.status !== "pending"}
                    onClick={() => setMakePayment(!makePayment)}
                  />
                }
                allowedPermissions={["can_update_rider_invoice"]}
              />
            )}
          </div>
        </div>

        <div
          className={tw`flex flex-col p-4 sm:p-10 bg-white shadow-md rounded-xl `}
        >
          <div className={tw`flex justify-between`}>
            <div>
              <img
                className={tw`h-[4rem] object-contain`}
                src={clientData?.logo}
                alt="logo"
              />
            </div>

            <div className={tw`text-right`}>
              <h2
                className={tw`text-2xl md:text-3xl font-semibold text-gray-500 `}
              >
                Statement #
              </h2>
              <span className={tw`mt-1 block text-gray-500`}>
                {order?.invoice_id}
              </span>
              <address className={tw`mt-1 not-italic text-gray-500 `}>
                {clientData?.address ?? "N/A"}
              </address>
            </div>
          </div>

          <div className={tw`mt-8 grid sm:grid-cols-2 gap-3`}>
            <div>
              <h3 className={tw` font-semibold text-gray-500 `}>Bill to:</h3>
              <h3 className={tw` font-semibold text-gray-500  capitalize`}>
                {order?.user?.full_name ?? "N/A"}
              </h3>
              <address className={tw`mt-2 not-italic text-gray-500`}>
                {order?.user?.mobile_number ?? "N/A"},<br />
                {order?.user?.email ?? "N/A"},<br />
                Kathmandu, Nepal
                <br />
              </address>
            </div>

            <div className={tw`sm:text-right space-y-2`}>
              <div
                className={tw`grid grid-cols-2 text-sm sm:grid-cols-1 gap-3 sm:gap-2`}
              >
                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Statement date:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500`}>
                    {moment(order?.created).format("YYYY/MM/DD ")}
                  </dd>
                </dl>
                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Payment Method:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500 uppercase`}>
                    {Array.isArray(order?.payment_method) ? (
                      <div>
                        {order.payment_method.map((p: any, i: number) => (
                          <div key={i}>
                            {p.payment_method} (Rs.{p.amount})
                          </div>
                        ))}
                      </div>
                    ) : typeof order?.payment_method === "object" &&
                      order?.payment_method !== null ? (
                      <span>
                        {order.payment_method.payment_method} (Rs.
                        {order.payment_method.amount})
                      </span>
                    ) : (
                      <span>{order?.payment_method ?? "N/A"}</span>
                    )}
                  </dd>
                </dl>
                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Payment date:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500`}>
                    {order?.settlement_date
                      ? moment(order?.settlement_date).format("YYYY/MM/DD")
                      : "N/A"}
                  </dd>
                </dl>
                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Payment Status:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500 uppercase`}>
                    {order?.status}
                  </dd>
                </dl>
              </div>
            </div>
          </div>

          <div className={tw`overflow-auto w-full`}>
            <table
              className={tw`mt-6 border border-gray-400 p-4 rounded-lg  space-y-4  w-full`}
            >
              <thead>
                <tr className={tw`text-center border-b border-gray-400 `}>
                  <th
                    className={tw`text-xs font-medium text-gray-500 uppercase`}
                  >
                    SN
                  </th>
                  <th
                    className={tw` text-xs font-medium text-gray-500 uppercase`}
                  >
                    WAYBILL
                  </th>
                  <th
                    className={tw` text-xs font-medium text-gray-500 uppercase`}
                  >
                    REFERENCE
                  </th>

                  <th
                    className={tw` text-xs font-medium text-gray-500 uppercase`}
                  >
                    RECEIVER
                  </th>
                  <th
                    className={tw` text-xs   font-medium text-gray-500 uppercasse`}
                  >
                    Pieces
                  </th>
                  <th
                    className={tw` text-xs   font-medium text-gray-500 uppercase`}
                  >
                    Weight
                  </th>
                  <th
                    className={tw` text-xs   font-medium text-gray-500 uppercase`}
                  >
                    COD
                  </th>

                  <th
                    className={tw` text-xs font-medium text-gray-500 uppercase`}
                  >
                    Collected Cod
                  </th>
                  <th
                    className={tw` text-xs   font-medium text-gray-500 uppercase`}
                  >
                    Commission
                  </th>
                </tr>
              </thead>
              <tbody>
                {order?.orders?.map((item: any, index: number) => (
                  <tr
                    key={index}
                    className={tw`text-center text-sm border border-gray-400`}
                  >
                    <td className={tw``}>
                      <p className={tw`font-medium text-gray-500 `}>
                        {index + 1}
                      </p>
                    </td>

                    <td className={tw``}>
                      <p className={tw` text-sm text-gray-500 `}>
                        {item?.tracking_number}
                      </p>
                      <p className={tw`text-sm text-gray-500 `}>
                        {moment(item?.created).format("YY-MM-DD HH:mm:ss")}
                      </p>
                      <p
                        className={tw`text-sm whitespace-nowrap text-center text-gray-500 `}
                      >
                        {item?.service_type?.name ??
                          item?.service_type ??
                          "N/A"}
                      </p>
                    </td>

                    <td className={tw``}>
                      <p className={tw` font-medium text-gray-500 `}>
                        {item?.reference_number}
                      </p>
                    </td>

                    <td className={tw``}>
                      <p
                        className={tw`font-medium text-gray-500  flex flex-col`}
                      >
                        {item?.receiver.full_name}

                        <p className={tw`font-sm`}>
                          {item?.receiver.primary_contact}
                        </p>
                        <p className={tw`font-sm`}>{item?.receiver.address}</p>
                      </p>
                    </td>

                    <td
                      className={tw`text-gray-500 text-center  whitespace-nowrap`}
                    >
                      {item?.total_piece ?? 0.0}
                    </td>
                    <td
                      className={tw`text-gray-500 text-center   whitespace-nowrap`}
                    >
                      {item?.total_weight ?? 0.0}
                    </td>

                    <td
                      className={tw`text-gray-500  text-center whitespace-nowrap`}
                    >
                      Rs. {item?.cod ?? 0.0}
                    </td>
                    <td>
                      <p className={tw`text-gray-500  `}>
                        Rs.{item?.collected_cod ?? 0.0}
                      </p>
                    </td>
                    <td>
                      <p className={tw`text-gray-500  `}>
                        Rs.{item?.commission ?? 0.0}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className={tw`mt-8 flex sm:justify-end`}>
            <div className={tw`w-full max-w-2xl sm:text-right space-y-2`}>
              <div className={tw`grid text-sm grid-cols-1 gap-3`}>
                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Total Cod:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500`}>
                    Rs. {order?.delivery_charge?.total_cod ?? 0.0}
                  </dd>
                </dl>

                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Collected Cod:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500`}>
                    Rs. {order?.delivery_charge?.collected ?? 0.0}
                  </dd>
                </dl>
                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Commission:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500`}>
                    Rs. {order?.commission}
                  </dd>
                </dl>

                <dl className={tw`grid sm:grid-cols-5 gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Payable Amount:
                  </dt>
                  <dd className={tw`col-span-2 text-gray-500`}>
                    Rs. {order?.invoice_amount ?? 0.0}
                  </dd>
                </dl>
              </div>
            </div>
          </div>

          <div className={tw`mt-6 sm:mt-12`}>
            <h4 className={tw`text-lg font-semibold text-gray-500 `}>
              Thank you!
            </h4>
            <p className={tw`text-gray-500`}>
              If you have any questions concerning this statement, use the
              following contact information:
            </p>
            <div className={tw`mt-2`}>
              <p className={tw`block text-sm font-medium text-gray-500 `}>
                {clientData?.email}
              </p>
            </div>
          </div>

          <p className={tw`mt-5 text-sm text-gray-500 mx-auto`}>
            © {new Date().getFullYear()} {clientData?.business_name}.
          </p>
        </div>
      </div>

      <Modal
        isOpen={makePayment}
        setIsOpen={setMakePayment}
        title={"Make Payment"}
        children={
          <>
            <MakePayment
              setMakePayment={setMakePayment}
              payableAmount={order?.invoice_amount}
            />
          </>
        }
      />
    </>
  );
};

export default InvoicePreview;
